
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/musik/entdecken",
      function () {
        return require("private-next-pages/musik/entdecken.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/musik/entdecken"])
      });
    }
  